import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';

const { GIFT_CARD } = anaConsts.EVENT_NAMES;

const { LINK_TRACKING_EVENT, ASYNC_PAGE_LOAD } = anaConsts;

class GiftCardsBindings {
    static triggerAsyncPageLoadAnalytics = eventData => {
        processEvent.process(ASYNC_PAGE_LOAD, { data: eventData });
    };

    static triggerLinkAnalytics = eventData => {
        processEvent.process(LINK_TRACKING_EVENT, { data: eventData });
    };

    static modalLoad = ({ pageName }) => {
        GiftCardsBindings.triggerAsyncPageLoadAnalytics({
            pageName: pageName,
            linkData: `${GIFT_CARD.CHECK_BALANCE}` //prop55
        });
    };

    static modalError = ({ error }) => {
        GiftCardsBindings.triggerLinkAnalytics({
            fieldErrors: ['gift card balance'], //prop28
            errorMessages: [`${error}`] //prop48
        });
    };
}

export default GiftCardsBindings;
